import axios from "axios";
import { toast } from "react-toastify";
import _ from "lodash";

import {
    GET_MALLS,
    ADD_MALL,
    UPDATE_MALL,
    GET_MALL,
    DELETE_MALL
} from "../types";

const basePath = process.env.REACT_APP_API_URL + "/api/mall";

export const getMalls = () => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/viewAll`);

        dispatch({
            type: GET_MALLS,
            payload: res.data
        });

        return res.data.malls;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const getPaginateMalls = (query) => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/viewAll`, {
            params: query
        });

        dispatch({
            type: GET_MALLS,
            payload: res.data
        });

        return res.data;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
}

export const addMall = data => async dispatch => {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };

    try {
        let formData = new FormData();

        formData.append("name", data.name);
        formData.append("address", data.address);
        // formData.append("postalCode", data.postalCode);
        formData.append("facebook", data.facebook);
        // formData.append("country", data.country);
        formData.append("website", data.website);
        // formData.append("description", data.description);

        const files = data.files;
        if (files.length) {
            files.forEach(file => {
                formData.append("images", file);
            });
        }

        const res = await axios.post(`${basePath}/add`, formData, config);

        dispatch({
            type: ADD_MALL,
            payload: res.data
        });

        toast.success("Mall Created.");

        return res.data;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
            return false;
        }
    }
};

export const getMall = id => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/view/${id}`);

        dispatch({ type: GET_MALL });

        return res.data.mall;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const updateMall = (data, id) => async dispatch => {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };

    try {
        let formData = new FormData();

        formData.append("name", data.name);
        formData.append("address", data.address);
        // formData.append("postalCode", data.postalCode);
        formData.append("facebook", data.facebook);
        // formData.append("country", data.country);
        formData.append("website", data.website);
        formData.append("description", data.description);

        if (_.isArray(data.images) && data.images.length) {
            const images = data.images;
            images.forEach(image => {
                formData.append("images[]", image);
            });
        }

        if (_.isArray(data.files) && data.files.length) {
            const files = data.files;
            files.forEach(file => {
                formData.append("files[]", file);
            });
        }

        const res = await axios.put(
            `${basePath}/update/${id}`,
            formData,
            config
        );

        dispatch({
            type: UPDATE_MALL,
            payload: res.data
        });

        toast.success("Mall Updated.");

        return res.data;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const deleteMall = id => async dispatch => {
    try {
        await axios.delete(`${basePath}/delete/${id}`);

        dispatch({
            type: DELETE_MALL,
            payload: id
        });

        toast.success("Mall Deleted.");
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};
